import * as API from './api'
import { PurchaseOption } from './purchase_option'

export class Checkout {
  public cashier: API.ICashier
  public purchaseOptions: PurchaseOption[]
  public defaultPurchaseOption: API.PurchaseOptionNameType
  public applyPromoCodePath: string
  public signedIn: boolean
  public monthly: boolean
  public newMembershipPlanDates: API.INewMembershipPlanDates
  public trial: boolean
  public trialLength: number
  public stateSelectOptions: string[][]
  public countrySelectOptions: string[][]
  public testimonials: API.ITestimonial[]

  public constructor(api: API.IMembershipCheckout) {
    this.cashier = api.cashier
    this.purchaseOptions = api.purchase_options.map((o) => new PurchaseOption(o))
    this.defaultPurchaseOption = api.default_purchase_option
    this.applyPromoCodePath = api.apply_promo_code_path
    this.signedIn = api.signed_in
    this.monthly = api.monthly
    this.newMembershipPlanDates = api.new_membership_plan_dates
    this.trial = api.trial
    this.trialLength = api.trialLength
    this.stateSelectOptions = api.state_select_options
    this.countrySelectOptions = api.country_select_options
    this.testimonials = api.testimonials
  }
}
